<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        class="pb-5 pr-sm-5 d-flex d-md-none"
        v-if="canSeeRequestEndorsement"
      >
        <BaseButton
          width="100%"
          outlined
          color="secondary"
          v-html="'SOLICITAR ENDOSSO'"
          @click="newRequestEndorsement"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        class="pb-5 d-flex d-md-none"
        v-if="canSeeNewEndorsement"
      >
        <BaseButton
          class="secondary white--text justify-start"
          width="100%"
          @click="newEndorsement"
        >
          <v-icon class="pr-9">
            fa-plus
          </v-icon>
          NOVO ENDOSSO
        </BaseButton>
      </v-col>
    </v-row>
    <v-row class="mb-5 mb-md-0">
      <v-col cols="auto" class="pr-5">
        <v-avatar class="lightGreen" size="10" />
        <p class="primary--text body-2 d-inline">
          Vigente
        </p>
      </v-col>
      <v-col cols="auto" class="pr-5">
        <v-avatar class="pink" size="10" />
        <p class="primary--text body-2 d-inline">
          Não vigente/cancelado
        </p>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  methods: {
    newEndorsement() {
      this.$router.push({
        name: "new endorsement policy",
        params: { id: this.$route.params.id }
      });
    },
    newRequestEndorsement() {
      this.$router.push({
        name: "new endorsement request policy",
        params: { id: this.$route.params.id }
      });
    }
  },
  props: {
    canSeeRequestEndorsement: {
      type: Boolean
    },
    canSeeNewEndorsement: {
      type: Boolean
    }
  }
};
</script>
